// Widget Scripts
import cardWidgetOne from './js/widgets/cardWidgetOne.js';
import cardWidgetTwo from './js/widgets/cardWidgetTwo.js';
import cardWidgetEmail from './js/widgets/cardWidgetEmail.js';
import swiperWidget from './js/widgets/swiperWidget.js'
import customCountdown from './js/siteInfoBanner.js';

// Custom Theme Scripts
import './js/localjs.js';
// import './js/siteInfoBanner.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    customCountdown();
    cardWidgetOne();
    cardWidgetTwo();
    cardWidgetEmail();
    swiperWidget();
  });
}